/**
 * Neon Auth Client Configuration
 *
 * Client-side authentication using Neon's native auth system.
 * Uses BetterAuthReactAdapter for React hooks support.
 */

import { createAuthClient } from '@neondatabase/auth'
import { BetterAuthReactAdapter } from '@neondatabase/auth/react/adapters'

// Create the auth client with React adapter
export const authClient = createAuthClient(
  import.meta.env.VITE_NEON_AUTH_URL,
  {
    adapter: BetterAuthReactAdapter(),
  }
)

// Export useSession hook from the authClient
export const { useSession } = authClient

// Export the auth client for use in components
export default authClient
